import React from 'react';
import { TopNavigation as NewTopNavigation } from './TopNavigation';
import { convertOldTopNavigationProps } from './converter.old';
import type { OldTopNavigationProps } from './converter.old';

export type TopNavigationProps = OldTopNavigationProps;

export const TopNavigation = (props: TopNavigationProps) => (
  <NewTopNavigation {...convertOldTopNavigationProps(props)} />
);
